import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfUse = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">Terms of Use</h1>
      <p className="mb-4">
        Welcome to Hayya! These terms of use outline the rules and regulations for the use of our website and services. By accessing this website, we assume you accept these terms and conditions in full. Do not continue to use Hayya s website if you do not accept all of the terms and conditions stated on this page.
      </p>
      <p className="mb-4">
        The following terminology applies to these Terms of Use, Privacy Policy, and any or all Agreements: Client, You, and Your refers to you, the person accessing this website and accepting the Company s terms and conditions. The Company, Ourselves, We, Our, and Us, refers to our Company. Party, Parties, or Us, refers to both the Client and ourselves, or either the Client or ourselves.
      </p>
      <p className="mb-4">
        Unless otherwise stated, Hayya and/or its licensors own the intellectual property rights for all material on Hayya. All intellectual property rights are reserved. You may view and/or print pages from Hayya for your own personal use subject to restrictions set in these terms and conditions.
      </p>
      <p className="mb-4">
        You must not:
        <ul className="list-disc list-inside">
          <li>Republish material from Hayya.tn</li>
          <li>Sell, rent, or sub-license material from Hayya.tn</li>
          <li>Reproduce, duplicate, or copy material from Hayya.tn</li>
          <li>Redistribute content from Hayya (unless content is specifically made for redistribution)</li>
        </ul>
      </p>
      <p className="mb-4">
        We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity, and limitations of liability.
      </p>
      <p className="mb-4">
        Your use of our website is subject to our privacy policy. Please review our Privacy Policy, which also governs the website and informs users of our data collection practices.
      </p>
      <p className="mb-4">
        These Terms of Use are governed by and construed in accordance with the laws of [Your Jurisdiction], and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.
      </p>
      <p className="mb-4">
        If you have any questions about these Terms of Use, please contact us at Contact@hayya.com.
      </p>

      <div className="mt-8">
        <Link to="/signup" className="bg-pink-600 hover:bg-pink-700 text-white font-bold py-1 px-2 rounded">
          Back
        </Link>
      </div>
    </div>
  );
};

export default TermsOfUse;
